import { Radio, Badge } from 'antd';
import type { RadioGroupProps } from 'antd';
import { FC, Key } from 'react';
import styles from './index.module.less';

interface Tab {
  label?: string;
  key?: Key;
  value?: string;
  count?: number;
}

const { Group, Button } = Radio;

interface TabsProps extends RadioGroupProps {
  tabs?: Tab[];
}

const renderTabs = (tabs: Tab[] = []) => {
  if (!Array.isArray(tabs)) {
    return;
  }

  return tabs.map(tab => {
    const { count, label, value } = tab;
    if (count) {
      return (
        <Button value={value} key={value}>
          <Badge
            className={styles.badge}
            overflowCount={99}
            count={count}>{label}
          </Badge>
        </Button>
      );
    }
    return (
      <Button value={value} key={value}>{label}</Button>
    );
  });
};


const Tabs: FC<TabsProps> = ({ tabs, ...restProps }) => {
  return (
    <div className={styles['group-wrapper']}>
      <Group
        {...restProps}>
        {renderTabs(tabs)}
      </Group>
    </div>
  );
};

export default Tabs;
